<template>
  <div class="section-scroll section-view section-offset-bottom" v-if="list.length">
    <div class="rr-products">
      <div class="rr-products-header rr-products-header--with-button">
        <div class="section-view-title-content section-view-title-content--flex rr-products-title">
          БЛОГ САДОВОДА
          <div class="rr-products-arrows" v-if="sliderView.showArrows">
            <div class="rr-products-arrow" @click="moveSlider(-1)" :class="{'rr-products-arrow--disabled': sliderView.isFirstPage}">
              <svg viewBox="0 0 22 38" xmlns="http://www.w3.org/2000/svg">
                <path d="M19.9706 2.02944L3 19L19.9705 35.9706" stroke-width="4" stroke-linecap="round"></path>
              </svg>
            </div>
            <div class="rr-products-arrow" @click="moveSlider(1)" :class="{'rr-products-arrow--disabled': sliderView.isLastPage}">
              <svg viewBox="0 0 23 38" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.63881 2.02944L19.6094 19L2.63885 35.9706" stroke-width="4" stroke-linecap="round"></path>
              </svg>
            </div>
          </div>
        </div>
        <div class="rr-products-header-button">
          <a href="/blog" class="btn-main btn-big">
            <span class="btn-main-overlay">
              <span class="btn-main-content">
                Перейти в блог садовода
              </span>
            </span>
            <span class="btn-main-shadow"></span>
          </a>
        </div>
      </div>
      <div class="rr-products-slider">
        <div class="rr-products-slider-overlay rr-products-slider-overlay--articles" :style="'transform: translate3d(-' + sliderView.offset + 'px, 0, 0)'">
          <div class="gp-grid-col rr-products-slide rr-products-slide--article" v-for="item in list" :key="item.id">
            <a :href="item.url" class="pv pv--a">
              <div class="pv-picture">
                <img class="pv-picture-main pv-picture-main--show" :src="item.image" alt="" loading="lazy"/>
              </div>
              <div class="pv-content">
                <div class="pv-title">
                  {{ item.title }}
                </div>
                <div class="pv-text" v-html="item.introtext" v-if="item.introtext"></div>
                <div class="pv-content-footer">
                  <div class="pv-date">
                    {{ item.created }}
                  </div>
                  <div class="pv-stats">
                    <div class="pv-stats-item" v-if="item.totalCount">
                      <svg viewBox="0 0 18 14" class="pv-stats-icon pv-stats-icon--1" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.99999 0.25C13.044 0.25 16.4085 3.16 17.1142 7C16.4092 10.84 13.044 13.75 8.99999 13.75C4.95599 13.75 1.59149 10.84 0.885742 7C1.59074 3.16 4.95599 0.25 8.99999 0.25ZM8.99999 12.25C10.5296 12.2497 12.0138 11.7301 13.2096 10.7764C14.4055 9.82264 15.2422 8.49121 15.5827 7C15.2409 5.50998 14.4037 4.18 13.208 3.22752C12.0122 2.27504 10.5287 1.7564 8.99999 1.7564C7.47126 1.7564 5.98776 2.27504 4.79202 3.22752C3.59629 4.18 2.75907 5.50998 2.41724 7C2.75781 8.49121 3.5945 9.82264 4.79035 10.7764C5.9862 11.7301 7.47039 12.2497 8.99999 12.25ZM8.99999 10.375C8.10489 10.375 7.24644 10.0194 6.61351 9.38649C5.98057 8.75355 5.62499 7.89511 5.62499 7C5.62499 6.10489 5.98057 5.24645 6.61351 4.61351C7.24644 3.98058 8.10489 3.625 8.99999 3.625C9.8951 3.625 10.7535 3.98058 11.3865 4.61351C12.0194 5.24645 12.375 6.10489 12.375 7C12.375 7.89511 12.0194 8.75355 11.3865 9.38649C10.7535 10.0194 9.8951 10.375 8.99999 10.375ZM8.99999 8.875C9.49727 8.875 9.97419 8.67746 10.3258 8.32582C10.6774 7.97419 10.875 7.49728 10.875 7C10.875 6.50272 10.6774 6.02581 10.3258 5.67417C9.97419 5.32254 9.49727 5.125 8.99999 5.125C8.50271 5.125 8.0258 5.32254 7.67417 5.67417C7.32254 6.02581 7.12499 6.50272 7.12499 7C7.12499 7.49728 7.32254 7.97419 7.67417 8.32582C8.0258 8.67746 8.50271 8.875 8.99999 8.875Z"/>
                      </svg>
                      {{ item.totalCount }}
                    </div>
                    <div class="pv-stats-item">
                      <svg viewBox="0 0 16 14" class="pv-stats-icon pv-stats-icon--2" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.500001 4.74551C0.499606 4.15466 0.615765 3.56954 0.841826 3.02365C1.06789 2.47775 1.39941 1.98182 1.81741 1.56423C2.23541 1.14665 2.73168 0.815624 3.2778 0.590108C3.82392 0.364593 4.40916 0.24902 5 0.250006H11C13.4848 0.250006 15.5 2.27126 15.5 4.74551V13.75H5C2.51525 13.75 0.500001 11.7288 0.500001 9.25451V4.74551ZM14 12.25V4.74551C13.998 3.95088 13.6812 3.18944 13.1189 2.62797C12.5566 2.06651 11.7946 1.7508 11 1.75001H5C4.60614 1.74902 4.21595 1.82579 3.85182 1.97593C3.4877 2.12606 3.15679 2.3466 2.87807 2.62489C2.59936 2.90319 2.37832 3.23377 2.22764 3.59767C2.07697 3.96157 1.99961 4.35164 2 4.74551V9.25451C2.00199 10.0491 2.31884 10.8106 2.88114 11.372C3.44345 11.9335 4.20537 12.2492 5 12.25H14ZM9.5 6.25001H11V7.75001H9.5V6.25001ZM5 6.25001H6.5V7.75001H5V6.25001Z" />
                      </svg>
                      {{ item.commentCount }}
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'FrontBlog',
  data() {
    return {
      list: [],
      page: 0,
      slider: {
        step: 1,
        maxScroll: 0,
        scrollWidth: 0,
        slidesOnView: 0,
        slideWidth: 0,
      }
    }
  },
  mounted() {
    if (window.location.search.includes('ga-isr=yes')) {
      this.getList();
    }
    else {
      this.createObserver();
    }
  },
  methods: {
    getList() {
      axios.get('/blog/get/frontpage').then((response) => {
        if (response.data && response.data.length) {
          this.list = response.data
          this.$nextTick(() => {
            this.makeSlider()
          })
        }
      })
    },
    moveSlider(direction) {
      if ((direction == -1 && this.sliderView.isFirstPage) || (direction == 1 && this.sliderView.isLastPage)) {
        return
      }

      this.page += direction
    },
    makeSlider() {
      const slider = this.$el.querySelector('.rr-products-slider')
      if (!slider) {
        this.list = []
        return
      }

      const layoutWidth = slider.offsetWidth + 24

      if (window.innerWidth < 768) {
        this.slider.slideWidth = layoutWidth
      }
      else if (window.innerWidth < 1368) {
        this.slider.slideWidth = layoutWidth / 2
      }
      else {
        this.slider.slideWidth = layoutWidth / 3
      }

      for (const slide of this.$el.querySelectorAll('.rr-products-slide--article')) {
        slide.style.width = `${this.slider.slideWidth}px`
      }

      const overlay = slider.querySelector('.rr-products-slider-overlay');
      if (!overlay) {
        this.list = []
        return
      }

      if (window.innerWidth <= 641) {
        slider.addEventListener('scroll', () => {
          this.slider.scrollWidth = slider.scrollLeft < 0 ? 0 : slider.scrollLeft
        })
      }

      this.slider.maxScroll = overlay.offsetWidth - slider.offsetWidth
      this.slider.slidesOnView = Math.floor(layoutWidth / this.slider.slideWidth);
    },
    async createObserver() {
      await this.$nextTick()

      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.getList();
            observer.unobserve(entry.target)
          }
        })
      }, {
        root: null,
        rootMargin: `${window.innerHeight}px`,
        threshold: 0
      })

      observer.observe(this.$el.parentElement)
    },
  },
  computed: {
    sliderView() {
      const slider = {
        offset: 0,
        showArrows: false,
        isFirstPage: true,
        isLastPage: false,
        visibleProducts: []
      };

      if (!this.slider.maxScroll) {
        return slider
      }

      if (window.innerWidth > 641) {
        const startRangeIndex = this.page * this.slider.step;
        const startIndex = this.page == 0 ? 0 : startRangeIndex - 1;
        const endIndex = startRangeIndex + this.slider.slidesOnView + this.slider.step + 1;
        const visibleList = this.list.slice(startIndex, endIndex);
        for (let i = 0; i < visibleList.length; i++) {
          slider.visibleProducts.push(visibleList[i].id)
        }
      }
      else {
        const startRangeIndex = Math.floor(this.slider.scrollWidth / this.slider.slideWidth)
        const startIndex = startRangeIndex == 0 ? 0 : startRangeIndex - 1
        const endIndex = startRangeIndex + this.slider.slidesOnView + this.slider.step + 1
        const visibleList = this.list.slice(startIndex, endIndex)
        for (let i = 0; i < visibleList.length; i++) {
          slider.visibleProducts.push(visibleList[i].id)
        }
      }

      slider.offset = this.page * this.slider.slideWidth;
      if (slider.offset > this.slider.maxScroll) {
        slider.offset = this.slider.maxScroll
      }
      slider.isFirstPage = slider.offset == 0;
      slider.isLastPage = slider.offset >= this.slider.maxScroll
      slider.showArrows = this.list.length > this.slider.slidesOnView

      return slider
    }
  }
}
</script>